interface Part {
  headers: { [key: string]: string };
  body: Uint8Array;
}

export function splitMultipartBody(buffer: Uint8Array, boundary: string): Part[] {
  const parts: Part[] = [];
  const boundaryBytes = new TextEncoder().encode(`--${boundary}`);
  const boundaryEndBytes = new TextEncoder().encode(`--${boundary}--`);
  const newline = new TextEncoder().encode('\r\n');
  const doubleNewline = new TextEncoder().encode('\r\n\r\n');

  let start = 0;

  while (start < buffer.length) {
    // Find the start of the next part
    const partStart = findSequence(buffer, boundaryBytes, start);

    if (partStart === -1 || partStart >= buffer.length - boundaryEndBytes.length) {
      console.log('No more parts found or end boundary reached at position:', partStart);
      break; // No more parts or only end boundary remains
    }

    // Find the end of headers (double newline)
    const headerEnd = findSequence(buffer, doubleNewline, partStart + boundaryBytes.length);

    if (headerEnd === -1) {
      console.warn('Malformed part: no header end found at position:', partStart);
      break; // Malformed part
    }

    // Extract headers
    const headerBytes = buffer.slice(partStart + boundaryBytes.length + newline.length, headerEnd);
    const headerText = new TextDecoder().decode(headerBytes);
    const headers = parseHeaders(headerText);

    // Find the start of the next boundary or end boundary
    const bodyStart = headerEnd + doubleNewline.length;
    let bodyEnd = findSequence(buffer, boundaryBytes, bodyStart);

    if (bodyEnd === -1) {
      bodyEnd = findSequence(buffer, boundaryEndBytes, bodyStart);
    }

    if (bodyEnd === -1) {
      bodyEnd = buffer.length; // Last part may not have a boundary
    }

    // Extract body
    const body = buffer.slice(bodyStart, bodyEnd);

    parts.push({ headers, body });
    start = bodyEnd;
  }

  return parts;
}

// Helper function to find a sequence in the buffer
function findSequence(buffer: Uint8Array, sequence: Uint8Array, start: number): number {
  for (let i = start; i <= buffer.length - sequence.length; i++) {
    let found = true;

    for (let j = 0; j < sequence.length; j++) {
      if (buffer[i + j] !== sequence[j]) {
        found = false;
        break;
      }
    }

    if (found) {
      return i;
    }
  }

  return -1;
}

// Helper function to parse headers
function parseHeaders(headerText: string): { [key: string]: string } {
  const headers: { [key: string]: string } = {};
  const lines = headerText.split('\r\n').filter((line) => line.trim() !== '');

  for (const line of lines) {
    const [key, value] = line.split(': ', 2).map((s) => s.trim());

    if (key && value) {
      headers[key.toLowerCase()] = value;
    }
  }

  return headers;
}
